import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Megaphone, Plus, Loader2, Target, Check } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export function CampaignSuggestions({ projectId, existingNames = [], onPick, onCustom, refreshKey }) {
  const [items, setItems] = useState([]);
  const [hasGoals, setHasGoals] = useState(true);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!projectId) return;
    setLoading(true);
    api.post(`/projects/${projectId}/campaign-suggestions`)
      .then((r) => { setItems(r.data.campaigns || []); setHasGoals(r.data.has_goals !== false); })
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [projectId, refreshKey]);

  return (
    <div className="glass rounded-2xl p-5 border border-primary/20" data-testid="campaign-suggestions">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
        <div>
          <h2 className="font-bold text-base md:text-lg flex items-center gap-2"><Megaphone className="w-5 h-5 text-primary" /> حملات مقترحة بناءً على مدخلاتك وأهدافك</h2>
          <p className="text-xs text-muted-foreground">كل حملة تخدم نتيجة محددة من أهدافك المعتمدة — أنشئها بضغطة، أو أضف حملة باسمك</p>
        </div>
        <Button size="sm" variant="outline" onClick={onCustom} className="gap-1 border-primary/40 text-primary" data-testid="add-custom-campaign-btn"><Plus className="w-3.5 h-3.5" /> أضف حملة من اختيارك</Button>
      </div>
      {loading ? (
        <div className="flex items-center gap-2 text-sm text-muted-foreground py-3"><Loader2 className="w-4 h-4 animate-spin" /> يجهّز الحملات المناسبة لأهدافك…</div>
      ) : !hasGoals ? (
        <div className="text-sm text-muted-foreground flex items-center gap-2 flex-wrap" data-testid="campaign-suggestions-no-goals">
          <Target className="w-4 h-4 text-amber-500" /> اعتمد أهدافك أولاً لنقترح حملات تقود إليها.
          <Link to="/app/goals" className="text-primary font-bold hover:underline">اعتماد الأهداف</Link>
        </div>
      ) : !items.length ? (
        <p className="text-sm text-muted-foreground">لا توجد اقتراحات بعد — أضف حملة من اختيارك.</p>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((c, i) => {
            const made = existingNames.includes(c.name);
            return (
              <div key={i} className={`rounded-xl border p-3 flex flex-col gap-2 ${made ? "border-emerald-500/30 bg-emerald-500/5" : "border-border bg-secondary/50"}`} data-testid={`campaign-suggestion-${i}`}>
                <div className="font-bold text-sm">{c.name}</div>
                {c.idea && <p className="text-xs text-muted-foreground leading-relaxed line-clamp-3">{c.idea}</p>}
                {c.serves && <p className="text-[11px] text-primary">تخدم: {c.serves}</p>}
                <div className="mt-auto flex items-center justify-between text-[11px] text-muted-foreground">
                  <span>{c.platform}{c.timing ? ` · ${c.timing}` : ""}</span>
                </div>
                {made ? (
                  <span className="text-xs text-emerald-500 flex items-center gap-1"><Check className="w-3.5 h-3.5" /> تم إنشاؤها</span>
                ) : (
                  <Button size="sm" onClick={() => onPick(c)} className="bg-primary hover:bg-primary/90 text-white h-8 text-xs" data-testid={`create-suggested-campaign-${i}`}>أنشئ هذه الحملة</Button>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
